import { observable } from 'mobx';

export type ChangeFeeElementResponseArgs = {
  id: number;
  content: string;
};

export type ChangeFeeElementArgs = {
  id: number;
  content: string;
};

export const convertChangeFeeElementResponseToArgs = (response: ChangeFeeElementResponseArgs) => {
  const args: ChangeFeeElementArgs = {
    id: response.id,
    content: response.content
  };
  return args;
};

export default class ChangeFeeElement {
  @observable
  id: number;

  @observable
  content: string;

  constructor(args: ChangeFeeElementArgs) {
    this.id = args.id;
    this.content = args.content;
  }

  get type() {
    return 'change_fee';
  }

  get title() {
    return '変更手数料';
  }

  get summary() {
    return this.content;
  }

  get name() {
    return this.title;
  }

  detail() {
    return '';
  }
}
